import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const BuildingRiskUserGuard = createFeatureGuard(Feature.BuildingRiskUser, Feature.BuildingRiskEditor);